import { render, staticRenderFns } from "./Shipment.vue?vue&type=template&id=c9b3cd04&scoped=true"
import script from "./Shipment.vue?vue&type=script&lang=js"
export * from "./Shipment.vue?vue&type=script&lang=js"
import style0 from "./Shipment.scss?vue&type=style&index=0&id=c9b3cd04&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b3cd04",
  null
  
)

export default component.exports